/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/components/customer-special-price-edit-button/shop.customer-special-price-edit-button.component.ts.
 */
import {Component, Input} from '@angular/core';
import {Artikel} from '../../../../models/artikel';
import {MatDialog} from '@angular/material/dialog';
import {
  ShopDialogsCustomerSpecialPriceListComponent
} from '../../dialogs/customer-special-price-list/shop.dialogs.customer-special-price-list.component';
import {AppEventService} from '../../../../services/app.event.service';

/**
 * Zweck: Beschreibt class ShopCustomerSpecialPriceEditButtonComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    selector: 'customer-special-price-edit-button',
    templateUrl: 'shop.customer-special-price-edit-button.component.html',
    styleUrls: ['shop.customer-special-price-edit-button.component.scss'],
    standalone: false
})
export class ShopCustomerSpecialPriceEditButtonComponent {
  @Input() artikel: Artikel;
  @Input() disabled = false;

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private dialog: MatDialog, private esvc: AppEventService) {
  }

/**
 * Beschreibt Methode click und ihren Rückgabevertrag.
 */
  click() {
    const ref = this.dialog.open(ShopDialogsCustomerSpecialPriceListComponent, {
      data: this.artikel,
      disableClose: true,
    });

    ref.afterClosed().subscribe(res => {
      if (res === true) {
        this.esvc.addGuiEvent('ShopCustomerSpecialPriceChanged');
      }
    });
  }
}
